<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="d-flex form-heading title-section form-section ">
              <p class="form-title text-center" style="font-size: 35px;">
                Surplus Lines Statement (Form SL-8)
              </p>

            </article>
            <article class="input-section form-section">
              <p ></p>
              <p class="notice-form-date-wa" style="text-align: left;"><b>State of Connecticut</b></p>
              <p class="notice-form-date-wa" style="text-align: left;margin-bottom: 20px"> <b>Insurance Department (Rev. 07/2013) </b></p>
                <p style="text-align: left;"> 1. Name and Address of Surplus Lines Broker</p>
                <p style="text-align: left;"> Isaac Peck - 6353 El Cajon Blvd, Suite 124-605, San Diego, CA 92115</p>

              <div class="row">
                <div class="col-md-6">
                <p style="text-align: left;"> 2. Producing Agent (not agency)</p>
                </div>
                <div class="col-md-6">
                  <p style="text-align: left;"> 2a. CT License No.</p>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <p style="text-align: left;"> Isaac Peck</p>
                </div>
                <div class="col-md-6">
                  <p style="text-align: left;"> </p>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                <p style="text-align: left;"> 3. Agency Represented</p>
                </div>
                <div class="col-md-6">
                  <p style="text-align: left;">  3a. CT License No.</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <p style="text-align: left;"> </p>
                </div>
                <div class="col-md-6">
                  <p style="text-align: left;">  2093119</p>
                </div>
              </div>


                <p style="text-align: left;"> 4. Name and Location on Risk</p>
                <p style="text-align: left;"> {{ quote.fullLegalNameOfApplicant }} {{ quote.customer.address }} {{ quote.customer.city }} {{ quote.customer.state }} {{ quote.customer.zipCode }}</p>
              <br />
              <p style="text-align: left;"> 5a. Surplus Lines Insurer(s) and NAIC No.</p>
                <p style="text-align: left;"> United National Insurance Company NAIC No. 13064</p>
              <br />
                <p style="text-align: left;"> 5b. Surplus Lines Insurer(s) and NAIC No.</p>



              <div class="row">
                <div class="col-md-4">
                  <p style="text-align: left;"> 6. Kind of Insurance</p>
                </div>
                <div class="col-md-4">
                  <p style="text-align: left;"> 6a. Limits</p>
                </div>
                <div class="col-md-4">
                  <p style="text-align: left;"> 6b. Risk Description</p>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <p style="text-align: left;"> Professional Liability</p>
                </div>
                <div class="col-md-4">
                  <p style="text-align: left;"> {{ coverages[quote.coverage].limitOfCoverage }}</p>
                </div>
                <div class="col-md-4">
                  <p style="text-align: left;"> </p>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <p style="text-align: left;">7. Type of Policy</p>
                </div>
                <div class="col-md-6">
                  <p style="text-align: left;">7b. Reason for Placement</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                </div>
                <div class="col-md-6">
                  <p style="text-align: left;">Home Inspector</p>
                </div>
              </div>


              <div class="row">
                <div class="col-md-4">
                  <p style="text-align: left;">8. Premium</p>
                </div>
                <div class="col-md-4">
                  <p style="text-align: left;">8a.</p>
                </div>
                <div class="col-md-4">
                  <p style="text-align: left;">8b. Policy Period</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <p style="text-align: left;">{{ coverages[quote.coverage].premium }}</p>
                </div>
                <div class="col-md-4">
                  <p style="text-align: left;"></p>
                </div>
                <div class="col-md-4">
                  <p style="text-align: left;"></p>
                </div>
              </div>


                <p style="text-align: left;">9. Does the undersigned broker have on file evidence of declination by three licensed insurers and ineligibility for any residual market mechanism
                per 38a-741 C.S.G?</p>
              <div class="row">
                <div class="col-md-6">
                  <p style="text-align: left;">9a. Broker Service Fee</p>
                </div>
                <div class="col-md-6">
                  <p style="text-align: left;">9b. Producer Service Fee</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <p style="text-align: left;">$150.00</p>
                </div>
                <div class="col-md-6">
                  <p style="text-align: left;"></p>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <br />
                </div>
              </div>
                <p class="mb-3 ar-sl-disclosure text-center" >
                 
                    <b>
                      STATEMENT BY INSURED
                    </b>
                  </p>
              <p class="mb-3 ct-sl-disclosure">I/We, the named insured, state that on {{ formattedCurrentDate() }}, I/We directed the licensed producing agent
              named on this Surplus Lines Statement to obtain insurance coverage described herein; that I/We were informed by said producing
              agent that he/she made a diligent effort to place this risk with licensed insurers authorized to transact the class of insurance involved
              and which accept in the usual course of business, insurance on risks of the same class as the risk described herein; and that said
              companies accepted only part of or no part of the required insurance.</p>
              <p class="mb-3 ct-sl-disclosure">I/We, were further informed by said producing agent that the amount of insurance indicated herein could be obtained from
                certain insurers not licensed to transact business in the State of Connecticut. I/We therefore directed the producing agent named herein
                to obtain said insurance though the office of the licensed Surplus Lines Broker named herein. I/We have been advised by the
                producing agent named herein that such insurance represents only the excess over the amounts procurable from licensed insurers or
                the Connecticut residual market. I/We have been advised that, in addition to commissions, I/We will be charged a service fee as set
                out in 9a and 9b.</p>
              <div class="row">

                <div class="col-md-8">
                  <section class="notice-form mt-3">
                    <p class="notice-form-date" style="text-align: left">Signature of Insured:</p>
                    <input
                      type="text"
                      class="orep-text-input notice-input"
                      placeholder="Type Your Name to Sign"
                      name="slDisclosureSignature"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                      v-model="quote.slDisclosureSignature"
                    >
                    <span
                      v-show="errors.has('slDisclosureSignature')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('slDisclosureSignature') | filterText }}</span>
                  </section>
                </div>
              </div>
              <p class="mb-3 ar-sl-disclosure text-center" >
               
                  <b>
                    STATEMENT BY SURPLUS LINES BROKER
                  </b>
                </p>
              <p class="mb-3 ct-sl-disclosure">I, as a licensed Surplus Lines Broker, authorized to transact insurance with the surplus lines insurer(s) named on this Surplus
                Lines Statement, depose and declare under the penalties provided for false statements that the diligent effort has been made to procure
                said insurance coverage from licensed insurers which are authorized to transact the class of insurance involved and which accept in the
                usual course of business, insurance on risks of the same class described herein. This insurance has been procured with the surplus lines
                insurer(s) named on this Surplus Lines Statement, which insurance is only the excess over amounts procurable from licensed insurers.</p>

              <div class="row">
                <div class="col-md-4">
                  <section class="notice-form-date-fl">
                    <p class="mb-3 ar-sl-disclosure" style="margin-left: 50px">
                    </p>

                  </section>
                </div>

                <div class="col-md-4">
                  <section class="notice-form-date-fl">
                    <p class="mb-3 ar-sl-disclosure">
                      Signature of Surplus Lines Broker:

                    </p>

                  </section>
                </div>
                <div class="col-md-4">
                  <section class="notice-form-date-fl">
                    <img src="../../../public/assets/images/sign.png" alt="Sign" style="max-height: 40px;">
                  </section>
                </div>
              </div>

            </article>
          </form>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">Broker Service Fee
            <router-link :to="{name:'property-inspector-7'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToPrev('property-inspector-1')"></button>
              <button class="pagination-dots" @click="navigateToPrev('property-inspector-2')"></button>
              <button class="pagination-dots" @click="navigateToPrev('property-inspector-3')"></button>
              <button class="pagination-dots" @click="navigateToPrev('property-inspector-4')"></button>
              <button class="pagination-dots" @click="navigateToPrev('property-inspector-5')" v-if="!state.signedInUser"></button>
              <button class="pagination-dots" @click="navigateToPrev('property-inspector-6')"></button>
              <button class="pagination-dots" @click="navigateToPrev('property-inspector-7')"               v-if="quote.applicantOrAssociateHasAnyOtherProfessionalLicense === 'true' && (checkServices('real estate agent') || checkServices('contractor') || checkServices('engineer') || checkServices('pest inspector'))"
              ></button>
              <span class="pagination-dots pagination-current"></span>
            </article>
            <button
              class="next-btn mont spaced text-uppercase"
              @click="formSubmit()"
              :disabled="!state.pageSlDisclosureIsValid"
              :class="{submitDisabled: !state.pageSlDisclosureIsValid}"
            >Submit</button>
          </section>
        </div>
      </div>
    </div>
    <div v-if="!!loading"
         class="position-fixed d-flex justify-content-center align-items-center w-100 h-100 bg-dark"
         style="opacity: 0.7; top: 0; left: 0;">
      <span class="text-white" style="font-size: 16px">Processing...</span>
    </div>

  </div>
</template>

<script>
  import $ from "jquery";
  import moment from 'moment';
  import { STATUS } from "../../utils/constants";

  export default {
    name: "property-inspector-ct-sl-disclosure",
    data() {
      return {
        loading: false
      };
    },
    computed: {
      quote() {
        return this.$store.state.homeInspector.quote;
      },
      coverages() {
        return this.$store.state.homeInspector.coverages;
      },
      state() {
        return this.$store.state.homeInspector;
      },
      errorMsg() {
        return this.$store.state.homeInspector.errorMsg;
      },
    },
    watch: {
      errorMsg: {
        handler() {
          if (this.errorMsg) {
            this.loading = false;
            this.$notify({
              group: 'error',
              type: 'error',
              title: 'Error',
              text: this.errorMsg
            });
          }
        }
      }
    },
    methods: {
      navigateToPrev(route) {
        this.$router.push({
          name: route
        });
      },
      next(routeName) {
        this.$router.push({
          name: routeName
        });
      },
      checkServices(service) {
        return this.quote.applicantOrAssociateReportMode.includes(service);
      },
      validateBeforeSubmit() {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.state.pageSlDisclosureIsValid = true;
            return;
          }
          this.state.pageSlDisclosureIsValid = false;
        });
      },

      formattedCurrentDate() {
        return moment(this.quote.applicantPrincipleEsignatureDatetime).format('YYYY-MM-DD');
      },
      formSubmit() {
        this.loading = true;
        this.quote.status = STATUS.Submitted;
        this.$store.dispatch('homeInspector/createSlDisclosure');
      }

    },


    filters: {
      filterText(x) {
        if (x !== undefined) {
          if (x.indexOf("req") !== -1) {
            return "This field is required";
          } else {
            return x.replace("_", " ");
          }
        }
      }
    },

    mounted() {
      $('html, body').animate({
        scrollTop: $('.orep-header').offset().top
      }, 500);
    },

    components: {}
  };
</script>

<style scoped>
  strong {
    text-decoration: underline;
  }
  .form-inline > label {
    width: 82px;
    text-align: left;
  }
  .form-heading > p {
    font-size: 35px;
    width: 100%;
    text-align: center;
    margin: 0;
  }
  .form-errors,
  .js-input-errors {
    display: block;
    text-transform: initial;
    font-size: 13px;
    width: 90%;
    margin: auto;
    position: relative;
    top: -29px;
  }
  fieldset {
    font-size: 12px;
  }
  .logo {
    width: 150px;
    height: 45px;
    object-fit: contain;
  }
  h6 {
    font-size: 14px;
  }
  h5 {
    font-size: 16px;
  }
  .company-info-content {
    padding: 10px 30px;
    border: 1px solid black;
  }
  .fs-subtitle {
    margin: 20px 0;
    border-bottom: 2px solid black;
  }
  table.oreptable {
    font-size: 14px;
    margin-left: auto;
    margin-right: auto;
  }
  .gen-inf {
    display: flex;
    background: #eee none repeat scroll 0 0;
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 20px;
    margin-top: 20px;
    padding: 7px;
    text-align: left;
    height: 30px;
    border: 1px solid black;
  }
  .underline-value {
    margin-left: 10px;
    margin-right: 40px;
    border-bottom: 1px solid black;
    margin-bottom: 15px;
    font-weight: 700;
    font-size: 14px;
  }
  .table th, .table td {
    text-align: center;
    vertical-align: middle;
  }
  .table.ar td, .table.ar th {
    border-left: 1px solid #ddd !important;
    border-top: 1px solid #ddd !important;
    border-right: 1px solid #ddd !important;
  }
  .w-20 {
    width: 20%;
  }
  .blank_th {
    width: 210px;
  }
  .footer-company-info {
    background-color: yellow;
    border: 1px solid black;
    padding: 10px 20px 40px;
  }
  .form-check-input {
    position: relative;
    margin-left: 0;
  }
  .page-content p, .page-content li {
    font-size: 15px;
  }
  .p-56, .notice-list > li, .notice-info {
    padding-right: 56px;
  }
</style>


